import { useFormContext } from 'react-hook-form';
import { useLiberisContext } from '@repo/app-contexts/liberis';

import { companyType } from '@/components/loan-form/schema/loan-form.schema';
import { useMainHubStoreState } from '@/store/main-hub.store';
import { RequestedLoanValuesWithP24Agreements } from '@/components/loan-offer-data-process/form/form.schema';

import { BeneficientData } from './beneficient-data';
import { RepresentativeData } from './representative-data';

export function LiberisBeneficientData() {
  const { merchantResponseData } = useMainHubStoreState();
  const { activeBeneficientIndex } = useLiberisContext();
  const { getValues } = useFormContext<RequestedLoanValuesWithP24Agreements>();

  const currentBeneficient = getValues().person[activeBeneficientIndex];
  const renderRepresentative =
    currentBeneficient.isRepresentative && !currentBeneficient.isBeneficient;

  const selectedCompanyType = companyType(
    merchantResponseData?.data?.merchantData?.companyType || 'jednoosobowa',
  );
  const isJdg = selectedCompanyType === 'jednoosobowa';

  if (isJdg || renderRepresentative) {
    return <RepresentativeData />;
  }

  return <BeneficientData key={`beneficientData-${activeBeneficientIndex}`} />;
}
